import bem from 'utils/bem';

export const block = bem('automation-post-modal-additional-details');
